import React, { useEffect, useRef, useContext } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import { Link, useNavigate } from "react-router-dom";
import { verifyAuth } from "../services/authservices";
import authService from "../services/authservices";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
const Affiliate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [offset, setOffset] = useState(0);
  const advanceSectionRef = useRef(null);
  const [userAuth, setAuth, userAuthref] = useState(false);

  const [siteDatacomes, setSiteData] = useState("");

  const [loginCheck, setloginCheck] = useState(false);

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  useEffect(() => {
    getSitedata();

    let userToken = localStorage.getItem("token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setloginCheck(false);
    }
  }, [0]);

  const getSitedata = async () => {
    try {
      const data = await authService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    const handleScroll = () => {
      if (advanceSectionRef.current) {
        const sectionTop = advanceSectionRef.current.offsetTop;
        const sectionHeight = advanceSectionRef.current.offsetHeight;
        const pageOffset = window.pageYOffset;

        if (
          pageOffset >= sectionTop &&
          pageOffset <= sectionTop + sectionHeight
        ) {
          setOffset(pageOffset - sectionTop);
        } else {
          setOffset(0);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    checkuserAuth();
  }, [0]);

  const checkuserAuth = async () => {
    const token = localStorage.getItem("token");
    if (token != null) {
      try {
        const data = await verifyAuth(token);
        if (data && data.status) {
          setAuth(true);
        } else {
          setAuth(false);
        }
      } catch (error) {
        // console.error("Error auth user details:", error);
        setAuth(false);
      }
    } else {
      setAuth(false);
    }
  };

  const nav_page = () => {
    if (!userAuthref.current) {
      navigate("/register");
    } else {
      navigate("/home");
    }
  };
  return (
    <>
      <main className="wyscale_landing_main">
        <Header />

        <section className="dashboard_content_section">
          <div className="container">
            <div className="smart_dashboard_content" id="privacy-condition">
              <h2>{t("AffiliateProgram")}</h2>
              <div className="row">
                <div className="col-lg-12">
                  <div className="dash_board_profile_content">
                    <div className="contentpage">
                      <p>{t("JoinTheBinargeAffiliate")}</p>

                      <h3>{t("HowDoYouEarn")}</h3>
                      <ul className="num_lists">
                        <li>
                          {t("OneTimeCommissionOnTheFirstOrder")}
                          <ul className="my-2">
                            <li>{t("PremiumSubscription")}</li>
                            <li>{t("Promium&EliteTrade")}</li>
                            {/* <li>
                              Elite Trader subscription: You will receive a
                              one-time commission of 20 USD when a user
                              purchases their first Promium subscription.
                            </li>
                            <li>Elite Trader $39 per month</li> */}
                          </ul>
                        </li>
                        <li>
                          {t("OngoingCommissionOnRenewals")}
                          <ul className="my-2">
                            <li>{t("YouWillReceive")}</li>
                            <li>{t("CommissionIsAutomatically")}</li>
                          </ul>
                        </li>
                        <li>
                          {t("AffiliateProgramBenefits")}
                          <ul className="my-2">
                            <li>{t("DirectEarningModel")}</li>
                            <li>{t("NoInvestmentRisk")}</li>
                            <li>{t("AlsoSuitableForContentCreators")}</li>
                            <li>{t("Possibility")}</li>
                          </ul>
                        </li>
                        <li>
                          {t("HereHowToGetStarted")}
                          <ul className="my-2">
                            <li>{t("RegisterWithBinarge")}.</li>
                            <li>{t("ShareYourOwnReferralLink")}</li>
                            <li>{t("TrackYourIncome")}</li>
                          </ul>
                          <p className="mt-2">
                            {t("AffiliateProgramIsSimple")}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SubFooter />
      </main>
    </>
  );
};

export default Affiliate;
